import {
  CLEAR_PROP_SUCCESS,
  CREATE_INVOICE_ENTRY_SUCCESS,
  FETCH_ACTIVITY_NO_SUCCESS,
  FETCH_FORM_DATA_SUCCESS,
  FETCH_INVOICE_ENTRY_SUCCESS,
  FETCH_QUOTE_SUCCESS,
  FIND_TPW_SUCCESS,
  GET_INVOICE_ENTRY_SUCCESS,
  SAVE_INVOICE_ENTRY_QUERY,
  STORE_TOTAL_DATA_FOR_INVOICE,
  STORE_TOTAL_DATA_FOR_LABOUR_INVOICE,
  STORE_TOTAL_DATA_FOR_SPARE_INVOICE,
} from "../../constants/ActionTypes";


let spareSum = [];
let labourSum = [];


const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  tpwSno: '',
  quotations: [],
  activitySno: [],
  sparesTotal: [],
  labourTotal: [],
  changed: false,
  totalData: 0,
  tableData: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_INVOICE_ENTRY_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case CLEAR_PROP_SUCCESS: {
      return {
        ...state,
        resource: {},
        tpwSno: '',
        quotations: [],
        sparesTotal: [],
        labourTotal: [],
        changed: false,
        totalData: 0,
        activitySno: [],
      }
    }

    case FETCH_QUOTE_SUCCESS: {
      return {
        ...state,
        quotations: action.data,
        total: action.count,
      }
    }

    case FIND_TPW_SUCCESS: {
      return {
        ...state,
        tpwSno: action.data,
      }
    }

    case GET_INVOICE_ENTRY_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;
      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_INVOICE_ENTRY_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_FORM_DATA_SUCCESS: {
      return {
        ...state,
        tableData: action.data,
      }
    }

    case FETCH_INVOICE_ENTRY_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case STORE_TOTAL_DATA_FOR_INVOICE: {
      return {
        ...state,
        totalData: action.data.data,
        changed: true,
      }
    }

    case STORE_TOTAL_DATA_FOR_SPARE_INVOICE: {
      state.sparesTotal[action.data && action.data.index] = action.data && action.data.data;
      if (action.data && action.data.removeIndex) {
        state.sparesTotal[action.data.removeIndex] = 0;
      }
      return {
        ...state,
        sparesTotal: state.sparesTotal,
        changed: true,
      }
    }

    case STORE_TOTAL_DATA_FOR_LABOUR_INVOICE: {
      state.labourTotal[action.data && action.data.index] = action.data && action.data.data;
      if (action.data && action.data.removeIndex) {
        state.labourTotal[action.data.removeIndex] = 0;
      }
      return {
        ...state,
        labourTotal: state.labourTotal,
        changed: true,
      }
    }

    case FETCH_ACTIVITY_NO_SUCCESS: {

      return {
        ...state,
        activitySno: action.data,
      }
    }

    default:
      return state;
  }
}
